// extracted by mini-css-extract-plugin
module.exports = {"author":"Author-module--author--2kf8a","author__bio-twitter":"Author-module--author__bio-twitter--MufFK"};